import { Permissions } from './permissions'

export const Menus = {
    drawer: {
        sections: [
            {
                label: 'General',  
                elements: [
                    {
                        href: '/mis-notificaciones',
                        icon: 'fas fa-file-invoice',
                        label: 'Mis Notificaciones',
                        permissions: [
                            Permissions.ALL
                        ]
                    },
                    {
                        href: '/mapa',
                        icon: 'fas fa-map',
                        label: 'Mostrar Mapa',
                        permissions: [
                            Permissions.ALL
                        ]
                    },
                    {
                        href: '/centros-de-atencion',
                        icon: 'fas fa-user-circle',
                        label: 'Centros de Atención',
                        permissions: [
                            Permissions.ALL
                        ]
                    },
                    {
                        href: '/historial',
                        icon: 'fas fa-history',
                        label: 'Historial',
                        permissions: [
                            Permissions.ALL
                        ]
                    }
                ]
            },
            {
                label: 'Mi Sesión',
                elements: [
                    {
                        href: '/cambiar-password',
                        icon: 'fas fa-key',
                        label: 'Cambiar Password',
                        permissions: [
                            Permissions.ALL
                        ]
                    },
                    {
                        href: '/cerrar-sesion',
                        icon: 'fas fa-sign-out-alt',
                        label: 'Cerrar Sesión',
                        permissions: [
                            Permissions.ALL
                        ]
                    }
                ]
            }
       ]
    },
    menu: {
        sections: [
            {
                label: '¿Deseas cerrar tu sesión?',
                elements: [
                    {
                        href: '/finalizar-sesion',
                        icon: 'fas fa-sign-out-alt',
                        label: 'Finalizar Sesión',
                        permissions: [
                            Permissions.ALL
                        ]
                    }
                ]
            }
        ]
    },
    settings: {
        sections: [
            {
                elements: [
                    {
                        href: '/finalizar-sesion',
                        icon: 'fas fa-sign-out-alt',
                        permissions: [
                            Permissions.ALL
                        ]
                    }
                ]
            }
        ]
    }
}
